import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-left p-4" }
const _hoisted_2 = {
  key: 0,
  class: "jobtype font-weight-bold"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "address mb-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "customer"
}

import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

import { Dictionary, Inspector, SelectOption, Booking } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingTooltipTemplate',
  props: {
  templateModel: { type: Object, default: () => {} }
},
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');

const dictionary = computed((): Dictionary => store.getters['dictionary/current']);

const getBookingWithoutStoringInState = (payload: { id: string, cancelled: string }): Promise<Booking> => {
  return store.dispatch('diary/getBookingWithoutStoringInState', payload);
};

const props = __props;

const booking = computed(() => props.templateModel?.appointmentData);

const prepdate = ref('');
const cidate = ref('');

onMounted(() => {
  if (booking.value.prepbase && booking.value.connectedbooking) {
    getBookingWithoutStoringInState({id: booking.value.connectedbooking, cancelled: 'false'})
      .then((b: Booking) => {
        if (b.id) prepdate.value = b.bookingdate;
      })
      .catch((err) => {});
  } else if (booking.value.prep && booking.value.connectedbooking) {
    getBookingWithoutStoringInState({id: booking.value.connectedbooking, cancelled: 'false'})
      .then((b: Booking) => {
        if (b.id) cidate.value = b.bookingdate;
      })
      .catch((err) => {});
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (booking.value.jobtype)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h5", null, [
            (booking.value.prep)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Prep"))
              : _createCommentVNode("", true),
            (booking.value.share)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Shared"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(actProperty).shortReportType(booking.value.jobtype, booking.value.subtype, dictionary.value)), 1)
          ]),
          (prepdate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(Prep on " + _toDisplayString(prepdate.value) + ")", 1))
            : _createCommentVNode("", true),
          (cidate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(CI on " + _toDisplayString(cidate.value) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (booking.value.addressPreviewLine1 || booking.value.addressPreviewLine2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(booking.value.address.postcode) + " ", 1),
          _hoisted_8,
          _createTextVNode(_toDisplayString(booking.value.addressPreviewLine1), 1)
        ]))
      : _createCommentVNode("", true),
    (
        booking.value.customer &&
        (booking.value.customer.companyName || booking.value.customer.branchName)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(booking.value.customer.companyName) + " - " + _toDisplayString(booking.value.customer.branchName), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})